var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInSite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "515B2ED5-451D-49F2-9C68-FFCD06E64978") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Navigation/Tabs/In-site"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,8.2 L12,12.6 L13.8,12.6 L13.8,17 L15,17 L15,6 C13.344,6 12,7.232 12,8.2 Z M8.8,9.85 L7.6,9.85 L7.6,6 L6.4,6 L6.4,9.85 L5.2,9.85 L5.2,6 L4,6 L4,9.85 C4,11.0655 5.074,12.05 6.4,12.05 L6.4,17 L7.6,17 L7.6,12.05 C8.926,12.05 10,11.0655 10,9.85 L10,6 L8.8,6 L8.8,9.85 Z",
    id: "Sur-Place",
    fill: "#fff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#fff",
    strokeWidth: 1.5,
    fillRule: "nonzero",
    points: "10 0 19 6.33333333 19 19 1 19 1 6.33333333 10 0"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInSite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/in-site.a5c121965e06842f9a30bdf8ad091001.svg";